<template>
  <generic-modal :title="$t('new api key')" ref="generic_modal">
    <form>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("name") }}</label>
            <div class="control">
              <input
                class="input"
                type="text"
                :placeholder="$t('name')"
                v-model="meta.name"
              />
            </div>
          </div>
          <div class="field" v-if="meta.settings">
            <label class="label">{{ $t("expire time") }}</label>
            <div class="control">
              <input
                class="input"
                type="text"
                :placeholder="$t('expire time')"
                v-model="meta.settings.expire_time"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <generic-dropdown
              :title="$t('personality')"
              :placeholder="$t('select one')"
              :is_multiple="false"
              url="/assistant/personality/catalog"
              name_field="name"
              value_field="personality_id"
              @selected="personality_changed"
              ref="personality_dropdown"
            />
          </div>
          <div class="field" v-if="meta.settings">
            <label class="label">
              {{ $t("time unit") }}
            </label>
            <div class="select is-fullwidth">
              <select v-model="meta.settings.expire_time_unit">
                <option value="y">{{ $t("years") }}</option>
                <option value="w">{{ $t("weeks") }}</option>
                <option value="d">{{ $t("days") }}</option>
                <option value="h">{{ $t("hours") }}</option>
                <option value="m">{{ $t("minutes") }}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </form>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";

export default {
  name: "CreateAPIKeyModal",
  components: { GenericModal, GenericDropdown },
  data() {
    return {
      meta: {},
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.personality_uuid || !v.meta.name;
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;

      put("/assistant/api-key", { ...v.meta })
        .then(() => {
          v.$emit("success");
          v.close_modal();
        })
        .catch((error) => {
          error_message(error);
        });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        prompt: "",
        messages: [],
        settings: {},
      };
      v.error = "";
      v.$refs.personality_dropdown.clear();
      // v.uuid = "";
    },
    personality_changed(personality) {
      let v = this;
      if (personality) {
        v.meta.personality_uuid = personality.uuid;
        v.welcome_message = personality.first_message;
      }
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
